export default __webpack_public_path__ + "locales/es/SocialAuthWelcomeDialog.json?hash=6089d46776132bf974f0e43e0c062a88";